import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../shared/services/data.service';
import { Util } from '../shared/util';

@Injectable()
export class CandidatoService extends DataService {

  private url = this.urlApi + 'v1/candidato/';

  constructor(private http: HttpClient, private _ngZone: NgZone) {
    super();
  }

  getFull(idCandidato) {
    return this.http.get<any>(this.url + 'getFull/' + idCandidato)
      .catch(this.handleError);
  }

  getAnaliseDocumental(idCandidato) {
    return this.http.get<any>(this.url + 'getAnaliseDocumentalById/' + idCandidato)
      .catch(this.handleError);
  }

  getFullUnidade(idUnidade, cpf,idFase) {
    return this.http.get<any>(this.url + 'getFull/' + idUnidade + '/' + cpf + '/' + idFase)
      .catch(this.handleError);
  }

  getByCpf(cpf) {
    return this.http.get(this.url + 'getByCpf/' + cpf)
      .catch(this.handleError);
  }

  getByUnidade(idUnidade) {
    return this.http.get(this.url + 'getByUnidade/' + idUnidade)
      .catch(this.handleError);
  }

  getByUnidadeQuery(idUnidade) {
    return this.http.get(this.url + 'getByUnidadeQuery/' + idUnidade)
      .catch(this.handleError);
  }

  getInscritosComPosicaoDentroDasVagasByUnidade(idUnidade) {
    return this.http.get<any[]>(this.url + 'getInscritosComPosicaoDentroDasVagasByUnidade/' + idUnidade)
      .catch(this.handleError);
  }

  getInscritosComPosicaoDentroDasVagasByFaseUnidade(idFase, idUnidade) {
    return this.http.get<any[]>(this.url + 'getInscritosComPosicaoDentroDasVagasByFaseUnidade/' + idFase + '/' + idUnidade)
      .catch(this.handleError);
  }

  getInscritosComPosicaoDentroDasVagasByFaseUnidadeClassificacao(idFase, idUnidade, idClassificacao) {
    return this.http.get<any[]>(this.url + 'getInscritosDentroDasVagasByFaseUnidadeClassificacao/' + idFase + '/' + idUnidade + '/' + idClassificacao)
      .catch(this.handleError);
  }

  getAllFull(): any {
    return this.http.get(this.url + 'getAllFull/')
      .catch(this.handleError);
  }

  getAllFullQuery(): any {
    return this.http.get(this.url + 'getAllFullQuery/')
      .catch(this.handleError);
  }

  convocaCandidatos(convocacao) {
    return this.http.put(this.url + 'convocaCandidatos', convocacao)
      .catch(this.handleError);
  }

  reagendaCandidato(reagendamento): any {
    return this.http.put(this.url + 'reagendaCandidato', reagendamento)
      .catch(this.handleError);
  }

  downloadTermoAprovado(idCandidato) {
    this._ngZone.runOutsideAngular(() => {
      location.href = this.url + 'downloadTermoAprovado/' + idCandidato;
    });
  }

  encaminharExameToxicologico(idCandidato, idLaboratorio, nomeUsuario) {
    this._ngZone.runOutsideAngular(() =>
      location.href = this.url + 'encaminharExameToxicologico/' + idCandidato + '/' + idLaboratorio + '/' + nomeUsuario
    );
  }

  salvarResultadoExameToxicologico(resultadoExameToxicologico) {
    return this.http.put(this.url + 'salvarResultadoExameToxicologico', resultadoExameToxicologico)
      .catch(this.handleError);
  }

  encaminharExameMedicoPsicologico(idCandidato, idClinica, nomeUsuario) {
    this._ngZone.runOutsideAngular(() => {
      const queryParam = (!Util.isNullOrEmptyOrUndefined(idClinica)) ? '?idClinica=' + idClinica : '';
      location.href = this.url + 'encaminharExameMedicoPsicologico/' + idCandidato + '/' + nomeUsuario + queryParam;
    });
  }

  salvarResultadoExameMedicoPsicologico(resultadoExameMedicoPsicologico) {
    return this.http.put(this.url + 'salvarResultadoExameMedicoPsicologico', resultadoExameMedicoPsicologico)
      .catch(this.handleError);
  }

  encaminharCursoPratico(idCandidato, idCfc, nomeUsuario) {
    this._ngZone.runOutsideAngular(() =>
      location.href = this.url + 'encaminharCursoPratico/' + idCandidato + '/' + idCfc + '/' + nomeUsuario
    );
  }

  salvarResultadoCursoPratico(resultadoCursoPratico) {
    return this.http.put(this.url + 'salvarResultadoCursoPratico', resultadoCursoPratico)
      .catch(this.handleError);
  }

  encaminharProvaPratica(idCandidato, nomeUsuario) {
    this._ngZone.runOutsideAngular(() =>
      location.href = this.url + 'encaminharProvaPratica/' + idCandidato + '/' + nomeUsuario
    );
  }

  salvarResultadoProvaPratica(resultadoProvaPratica) {
    return this.http.put(this.url + 'salvarResultadoProvaPratica', resultadoProvaPratica)
      .catch(this.handleError);
  }

  getStatusCandidato() {
    return this.http.get(this.url + 'getStatusCandidato/')
      .catch(this.handleError);
  }

  getStatusCandidatoPodemSerAlterados() {
    return this.http.get(this.url + 'getStatusPodemSerAlterados/')
      .catch(this.handleError);
  }

  getHistoricoCandidato(idCandidato) {
    return this.http.get(this.url + 'getHistoricoCandidato/' + idCandidato)
      .catch(this.handleError);
  }

  alterarStatusCandidato(candidatoStatus) {
    return this.http.post(this.url + 'alterarStatus', candidatoStatus)
      .catch(this.handleError);
  }

  desclassificarCandidatoDocumentacao(idCandidato) {
    return this.http.get(this.url + 'desclassificarCandidatoDocumentacao/' + idCandidato)
      .catch(this.handleError);
  }

  enviarTermoAditivoAssinado(enviarTermoAditivoAssinado) {
    return this.http.post(this.url + 'enviarTermoAditivoAssinado', enviarTermoAditivoAssinado)
      .catch(this.handleError);
  }

  gerarTermoAditivo(idCandidato) {
    this._ngZone.runOutsideAngular(() => {
      location.href = this.url + 'gerarTermoAditivo/' + idCandidato;
    });
  }

  getVersaoTermoAditivoAtual(idCandidato) {
    return this.http.get(this.url + 'versaotermoaditivoatual/' + idCandidato)
      .catch(this.handleError);
  }

  concluirProcesso(idCandidato) {
    return this.http.get(this.url + 'concluirprocesso/' + idCandidato)
      .catch(this.handleError);
  }

  getTermosAditivosGeradosPorCandidato(idCandidato) {
    return this.http.get<any[]>(this.url + 'getTermosAditivosGerados/' + idCandidato)
      .catch(this.handleError);
  }

  inserirArquivoGeral(candidatoArquivoGeral) {
    return this.http.post(this.url + 'inserirArquivoGeral', candidatoArquivoGeral)
      .catch(this.handleError);
  }

  getArquivosGerais(idCandidato) {
    return this.http.get<any[]>(this.url + 'getArquivosGerais/' + idCandidato)
      .catch(this.handleError);
  }

  removerArquivoGeral(idCandidatoArquivoGeral) {
    return this.http.delete<any[]>(this.url + 'removerArquivoGeral/' + idCandidatoArquivoGeral)
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/candidato/candidato.service.ts